import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { getCamerasBySiteAlerts } from "../Alerts/AlertsUtils/getCamerasBySiteAlerts";
import { NavigateFunction } from "react-router-dom";

export const SiteDropDownSentinel = ({
  siteOptionsSentinel,
  loadingSitesSentinel,
  siteDropDownValueSentinel,
  setSiteDropDownValueSentinel,
  setCameraDropDownValueSentinel,
  setUserFiltersSentinel,
  setCameraOptionsSentinel,
  setLoadingCamerasSentinel,
  showUserDropDown,
  navBarCollapsed,
  navigate,
}: {
  siteOptionsSentinel: any;
  loadingSitesSentinel: boolean;
  siteDropDownValueSentinel: string | null;
  setSiteDropDownValueSentinel: Dispatcher<string | null>;
  setCameraDropDownValueSentinel: Dispatcher<string | null>;
  setUserFiltersSentinel: any;
  setCameraOptionsSentinel: any;
  setLoadingCamerasSentinel: Dispatcher<boolean>;
  showUserDropDown: boolean;
  navBarCollapsed: boolean;
  navigate: NavigateFunction;
}) => {
  const siteIds = new Map();
  siteOptionsSentinel.forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  // Create a Set to track unique names and ensure we only add each name once
  const uniqueNames = new Set<string>();
  const options: string[] = [];

  // First pass: collect unique names
  siteOptionsSentinel.forEach((object: any) => {
    if (!uniqueNames.has(object.name)) {
      uniqueNames.add(object.name);
      options.push(object.name);
    }
  });

  let sx: any;

  if (showUserDropDown && navBarCollapsed) {
    sx = { width: 175 };
  }

  if (showUserDropDown && !navBarCollapsed) {
    sx = { width: 150 };
  }

  if (!showUserDropDown && navBarCollapsed) {
    sx = { width: 240 };
  }

  if (!showUserDropDown && !navBarCollapsed) {
    sx = { width: 200 };
  }

  return (
    <div key="site_dropdown">
      <Autocomplete
        value={siteDropDownValueSentinel}
        disablePortal
        options={options}
        loading={loadingSitesSentinel}
        onChange={(event, value: any) => {
          if (value !== null) {
            setSiteDropDownValueSentinel(value);
            setCameraDropDownValueSentinel(null);
            getCamerasBySiteAlerts(
              [siteIds.get(value)],
              navigate,
              setCameraOptionsSentinel,
              setLoadingCamerasSentinel
            );
            setUserFiltersSentinel((previousState: any) => {
              return {
                ...previousState,
                site_ids: [siteIds.get(value)],
                camera_ids: [],
              };
            });
          } else {
            setSiteDropDownValueSentinel(value);
            setCameraDropDownValueSentinel(null);
            setCameraOptionsSentinel([]);
            setUserFiltersSentinel((previousState: any) => {
              return {
                ...previousState,
                site_ids: [],
                camera_ids: [],
              };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSitesSentinel ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
